module.exports = __webpack_public_path__ + "img/pathfinder-Paizo-Inc.-Ekaterina-Burmak.e6af6e24.jpg";